import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import { connect } from 'react-redux';
import { getNodeImages } from '../../stores/actions/installerActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import NodeImagesCardBody from './NodeImagesCardBody';


const style = {
    cardTitle,
    cardCategory: styles.cardCategory,
};


interface INodeImagesCardProps {
    hideAlert: () => void;
    nodeImages: any;
    nodeId: number;
    nodeName: string;
}

class NodeImagesCard extends React.Component<INodeImagesCardProps> {
    render() {
        const { nodeImages, nodeId, nodeName } = this.props;
        const headerText = 'Images';

        return (
            <ErrorComponent Children message='Error'>
                <GridContainer>
                    <GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            simple
                            justIcon
                            color='info'
                            style={closeSweetAlertStyle}
                            onClick={this.props.hideAlert}
                            data-testid='cancelButton'
                        >
                            <CancelIcon style={{ width: '20px', height: '20px' }} />
                        </Button>
                    </GridItem>
                </GridContainer>

                <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} data-testid='nodeImagesCard'>

                    <CardHeader color='info' icon>
                        <CardIcon color='info'>
                            <DescriptionOutlined />
                        </CardIcon>
                        <p style={{ ...style.cardCategory, textAlign: 'left' }}>Images of Node:</p>
                        <h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{nodeName}</h3>
                    </CardHeader>

                    <NodeImagesCardBody
                        hideAlert={this.props.hideAlert}
                        images={nodeImages}
                        nodeId={nodeId}
                    />
                </Card>
            </ErrorComponent>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        nodeImages: state.dashboard.nodeImages,
    }
}
const actions = { getNodeImages };
export const ExportCardWithStyles = dashboardStyle(NodeImagesCard);
export default connect(mapStateToProps, actions)(ExportCardWithStyles);
